// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/home/component/right/hotRecommend.less
// module id = 850
// module chunks = 42